import { OrdStatusEnum, SideEnum, type ExecutionReport, type Order } from '@talos/kyoko';

type ResubmitCandidate = Pick<Order | ExecutionReport, 'Side' | 'ExpressedOutcome' | 'OrdStatus'>;

/** New-model Close Position is a Sell of an expressed outcome. */
export function isPredictionCloseOrder(order: Pick<ResubmitCandidate, 'Side' | 'ExpressedOutcome'>): boolean {
  return order.ExpressedOutcome != null && order.Side === SideEnum.Sell;
}

/**
 * Filled (and other non-retry) prediction closes must not be resubmitted — that places a new Sell.
 * Canceled and rejected closes are a retry and clone like any other resubmit.
 * Non-close orders are unchanged.
 */
export function canResubmitPredictionClose(order: ResubmitCandidate): boolean {
  if (!isPredictionCloseOrder(order)) {
    return true;
  }

  return order.OrdStatus === OrdStatusEnum.Canceled || order.OrdStatus === OrdStatusEnum.Rejected;
}
